import ApiClient from '../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useGetMasterSystemAdminSupportEmail = () => {
    return useQuery({
        queryKey: ['get-master-system-admin-support-email'],
        queryFn: async () => {
            const response = await _apiClient.getMasterSystemAdminSupportEmail();

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Master Syste Admin Support Email.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
